import SubTitle from '../components/elements/sub-title';
import Title from '../components/elements/title';
import UnorderedList from '../components/elements/unordered-list';
import { CONTACT_EMAIL } from '../constants';

export const PrivacyPolicyFr = () => {
  return (
    <div>
      <Title>Déclaration de confidentialité</Title>
      <div className="my-2">Votre vie privée est importante pour nous.</div>
      <p className="my-2">Dernière mise à jour le 2 juin 2021</p>
      <SubTitle>Vos données personnelles</SubTitle>
      <div className="my-2">
        Vous les partagez avec nous afin que nous puissions vous servir au mieux. Il est important que vous sachiez
        également pourquoi nous demandons vos données personnelles et ce que nous en faisons. Ci-dessous, vous trouverez
        des explications sur certaines raisons pour lesquelles nous demandons des informations vous concernant et
        comment nous les obtenons et les utilisons. Veuillez lire attentivement cette politique de confidentialité car
        elle contient des informations essentielles sur la manière dont vos données personnelles sont traitées et sur
        les cookies utilisés. Lorsque nous faisons référence à "données personnelles" dans cette politique de
        confidentialité, nous entendons les informations que vous nous fournissez sur vous-même, telles que votre nom,
        votre adresse, votre adresse e-mail et votre numéro de téléphone, ainsi que les produits que vous avez achetés
        ou les e-mails que vous nous avez envoyés. En fournissant vos données personnelles, vous déclarez avoir pris
        connaissance de cette politique de confidentialité et acceptez expressément le traitement de ces données. Si
        vous avez des questions après avoir lu cela, veuillez nous en informer via {CONTACT_EMAIL}.
      </div>
      <SubTitle>Quelles données collectons-nous et pourquoi ?</SubTitle>
      <div className="my-2">
        Vous partagez des données avec nous de différentes manières. Nous utilisons des données que nous avons reçues de
        vous, ainsi que des données que nous avons collectées nous-mêmes. Par exemple, des données sur votre visite sur
        notre site Web. Vous n'êtes pas obligé de fournir vos données personnelles, mais comprenez que le refus de
        traitement peut rendre impossibles certaines prestations de services. Vous êtes seul responsable de l'exactitude
        de ces données.
      </div>
      <div className="mt-4">Nous n'utiliserons les données personnelles collectées que dans les buts suivants :</div>
      <UnorderedList>
        <div>
          <div className="font-semibold">Données anonymes</div>
          <div className="my-2">
            Il s'agit de données que vous partagez avec nous sans vous inscrire : adresse IP, comportement de
            navigation, provenance, termes de recherche. Nous utilisons ces données pour entretenir et améliorer notre
            site Web. Cela signifie que nous incluons des données personnelles dans des statistiques anonymes, à partir
            desquelles l'identité de personnes ou d'entreprises spécifiques ne peut pas être déduite, sur la base des
            intérêts légitimes de Gypsy de Saint-Tropez pour améliorer constamment son site Web et ses services.
          </div>
        </div>
        <div>
          <div className="font-semibold">Cookies</div>
          <div className="my-2">
            Le site Web utilise également des cookies qui collectent certaines données personnelles avec votre
            consentement explicite préalable. Nous utilisons ces données pour entretenir et améliorer notre site Web.
            Pour les dispositions relatives à l'utilisation des cookies, consultez la politique relative aux cookies.
          </div>
        </div>
        <div>
          <div className="font-semibold">Votre compte</div>
          <div className="my-2">
            Vous pouvez créer un compte sur notre site Web. Dans votre compte, nous stockons, entre autres, les
            informations suivantes : votre nom, votre adresse, votre numéro de téléphone, votre adresse e-mail, vos
            informations de livraison et de paiement, ainsi que les informations et les centres d'intérêt que vous avez
            fournis. Nous conservons ces informations afin que vous n'ayez pas à les saisir à chaque visite sur notre
            site Web ou lors de la passation d'une commande ultérieure. De plus, nous utilisons les coordonnées fournies
            pour vous contacter en cas de questions ou de commentaires sur votre commande, ou pour recueillir votre
            avis. La gestion de votre compte sur ce site Web est basée sur l'exécution d'un contrat que vous avez
            demandé. Vous pouvez toujours annuler votre compte.
          </div>
        </div>
        <div>
          <div className="font-semibold">Connexion via les médias externes</div>
          <div className="my-2">
            Si vous avez un profil sur les médias externes tels que Facebook, Google, ... vous pouvez vous connecter à
            Gypsy de Saint-Tropez via votre compte. Nous ne récupérons de ces comptes que les informations suivantes :
            nom, prénom et adresse e-mail. Ils ne peuvent pas consulter les données de votre compte. Vous pouvez
            toujours déconnecter ces données et votre compte dans vos paramètres.
          </div>
        </div>
        <div>
          <div className="font-semibold">Commande ou réservation en ligne</div>
          <div className="my-2">
            Pour passer une commande, nous avons besoin de votre nom, de votre adresse e-mail, de votre adresse, de vos
            informations de paiement et de votre numéro de téléphone. Nous avons besoin de ces informations pour la
            livraison et la facturation des produits que vous avez commandés, sur la base de la prestation de service
            que vous avez demandée. Nous utilisons également ces informations pour vous livrer votre commande, vous
            tenir informé de l'évolution de votre commande et vous contacter en cas de questions ou de commentaires sur
            votre commande. Si vous passez une commande et utilisez votre compte (voir "votre compte"), nous
            enregistrons cette commande en votre nom. Ces données sont utilisées pour effectuer des analyses
            statistiques et générales de votre comportement d'achat, ainsi que pour établir des profils.
          </div>
        </div>
        <div>
          <div className="font-semibold">Fraude</div>
          <div className="my-2">
            Vos données de paiement peuvent être utilisées pour détecter la fraude et d'autres activités illicites.
          </div>
        </div>
        <div>
          <div className="font-semibold">Inscription à la newsletter</div>
          <div className="my-2">
            Vous pouvez vous inscrire à nos différentes newsletters. Lors de votre inscription, nous vous demandons
            votre nom, votre adresse e-mail, votre numéro de téléphone, votre date de naissance et vos centres
            d'intérêt. Vous resterez ainsi informé des promotions, des offres spéciales et des dernières tendances, et
            nous pourrons vous inviter à des événements. Nous proposons des newsletters générales et personnalisées. Les
            newsletters personnalisées sont élaborées en fonction de vos données, telles que vos commandes précédentes,
            vos achats et votre comportement de navigation. Vous devez toujours donner votre consentement explicite et
            préalable pour cela. Si vous ne souhaitez plus recevoir de newsletters de notre part, vous pouvez vous
            désabonner à tout moment en suivant le lien en bas de l'e-mail que vous recevez.
          </div>
        </div>
        <div>
          <div className="font-semibold">Qui a accès à vos données personnelles ?</div>
          <div className="my-2">
            Au sein de Gypsy de Saint-Tropez, seules les personnes responsables qui en ont besoin dans le cadre de leurs
            fonctions ont accès aux données.
          </div>
        </div>
        <div>
          <div className="font-semibold">Transmission à des tiers</div>
          <div className="my-2">
            Nous faisons occasionnellement appel à un prestataire externe pour nous aider dans certaines tâches. Ces
            services peuvent inclure la livraison de produits, le traitement des paiements par carte de crédit/débit.
            Cela signifie que, pour certaines tâches ou enquêtes, nous pouvons temporairement transmettre des données
            personnelles à des tiers parce qu'ils en ont besoin pour exécuter le service en votre nom. Nous concluons
            toujours un accord contractuel avec ces prestataires de services et limitons les données que nous partageons
            avec des tiers aux seules fins pour lesquelles ils en ont besoin. Ces prestataires de services ne sont pas
            autorisés à utiliser vos données de leur propre initiative et doivent effacer vos données une fois qu'ils
            ont terminé la mission. Les tiers sont soumis à un contrôle strict pour garantir la protection de votre vie
            privée.
          </div>
          <div className="my-2">
            Nous pouvons également, dans de rares cas, divulguer vos données si nous y sommes légalement tenus en vertu
            de certaines lois et règlements, et/ou de décisions judiciaires. Il se peut que nous soyons tenus de
            divulguer vos données personnelles en vertu d'une ordonnance du tribunal ou pour nous conformer à d'autres
            exigences légales contraignantes. Dans ce cas, nous essaierons raisonnablement de vous informer à l'avance,
            sauf si cela est soumis à des restrictions légales.
          </div>
          <div className="my-2">
            Gypsy de Saint-Tropez ne vendra pas, ne louera pas, ni ne distribuera commercialement vos données
            personnelles à des tiers, sauf dans les cas décrits ci-dessus ou sauf avec votre consentement préalable.
          </div>
        </div>
        <div>
          <div className="font-semibold">Période de conservation de vos données</div>
          <div className="my-2">
            Nous conservons et traitons les données personnelles aussi longtemps que nécessaire aux fins du traitement
            et de la relation contractuelle entre vous et Gypsy de Saint-Tropez.
          </div>
        </div>
      </UnorderedList>
      <SubTitle>Contactez-nous</SubTitle>
      <div>
        <p>Gypsy Mode</p>
        <p>BE.0830.868.445</p>
        <p>Jan Hijoensstraat 7</p>
        <p>8800 Roeselare</p>
        <p>Belgique</p>
        <p>{CONTACT_EMAIL}</p>
      </div>
    </div>
  );
};
